import React, { useState } from "react";

import { RadioButtonProps } from "components/generic/RadioButton";
import { ErrorMessage, Field, FieldProps } from "formik";
import { ModalCentered } from "components/generic/ModalCentered";
import { Modal } from "react-bootstrap";

type Props = {
    name: string;
    radioButtonValues: RadioButtonProps[];
    orientation: "vertical" | "horizontal";
};

export const RadioButtonGroup: React.FunctionComponent<Props> = (props: Props) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    return (
        <>
            {props.radioButtonValues.map((x, index) => (
                <div className={props.orientation === "horizontal" ? " radiobutton-container-horizontal" : ""} key={x.label}>
                    <label htmlFor={x.value} className="radiobutton-label" key={x.value}>
                        <div className={"radiobutton-inner " + (props.orientation === "vertical" ? "radiobutton-inner--vertical" : "")}>
                           <Field key={x.value} name={props.name}>
                                {(fieldProps: FieldProps<string>) => (
                                    <input
                                        id={x.value}
                                        type="radio"
                                        checked={x.value === fieldProps.field.value}
                                        className={"radiobutton"}
                                        value={x.value}
                                        name={props.name}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            // Default formik on change first
                                            fieldProps.field.onChange(e);
                                            if (x.message) {
                                                setShowModal(true);
                                                setSelectedIndex(index);
                                            } else {
                                                setShowModal(false);
                                            }
                                        }}
                                    />
                                )}
                            </Field>
                            <div className="radiobutton-labels">
                                <span>{x.label}</span>
                                {x.secondaryLabel ? <span className="radiobutton-secondary-label">{x.secondaryLabel}</span> : null}
                            </div>
                        </div>
                    </label>
                </div>
            ))}
            <ErrorMessage name={props.name} component="div" className="error-msg" />
            <ModalCentered size="sm" show={showModal} onHide={() => setShowModal(false)}>
                <div className="custom-dialog">
                    <Modal.Header closeButton />
                    {selectedIndex !== null ? (
                        <div>
                            {(() => {
                                const radioButtonValue = props.radioButtonValues[selectedIndex];
                                if (radioButtonValue.url !== null && radioButtonValue.url !== undefined && radioButtonValue.url.trim() !== "") {
                                    return (
                                        <a href={radioButtonValue.url} target="_blank" rel="noreferrer">
                                            {radioButtonValue.message}
                                        </a>
                                    );
                                }
                                return radioButtonValue.message;
                            })()}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </ModalCentered>
        </>
    );
};
